import { connect } from 'react-redux';

import { simoSubPage } from 'decorators/subPage';
import ExpireSubscription from './ExpireSubscription';
import { expireSimoSubscription } from 'actions/simoSubs';
import {
  getSubmitSucceeded,
  getSubmitStatus,
  getIsAdmin,
  getIncludedInGroups,
  getLoggedInUser,
} from 'reducers';
import withSimoExpiryTypes from 'decorators/withSimoExpiryTypes';

const mapStateToProps = (state) => ({
  submitSucceeded: getSubmitSucceeded(state, 'expireSub'),
  submitStatus: getSubmitStatus(state, 'expireSub'),
  isAdmin: getIsAdmin(state),
  onSuccessRedirectUrl: (id) => `/simo/subscriptions/${id}/view`,
  isReseller: getIncludedInGroups(state, ['RESELLER']),
  loggedInUser: getLoggedInUser(state),
  isSimo: true,
  showBypass: false,
  showProration: false,
  showPin: false,
});

const mapDispatchToProps = (dispatch, { subId }) => ({
  onSubmit: (values) => dispatch(expireSimoSubscription(subId, values)),
});

export default simoSubPage(
  withSimoExpiryTypes(
    connect(mapStateToProps, mapDispatchToProps)(ExpireSubscription),
  ),
);
